export default {
    listing: {
        pageTitle: 'Campagnes',
        tabs: {
            all: 'Toutes',
            aging: 'Vieillissantes',
            archived: 'Archivées',
        },
        listingHeaders: {
            name: 'Nom',
            createdDate: 'Date de création',
            numberContacts: 'Nombre de contacts',
            status: 'Statut',
            actions: 'Actions',
        },
        status: {
            allSent: 'Envoyée à tous',
            partiallySent: 'Partiellement envoyée',
            errors: 'Erreurs présentes',
        },
        actions: {
            archive: 'Archiver',
            manage: 'Gérer',
        },
        errors: {
            fetching: 'Une erreur s\'est produite lors de la récupération des campagnes.',
        },
        noCampaign: 'Aucune campagne.',
        wouldYouLikeToAddOne: 'Voulez-vous en ajouter une?',
        createCampaign: 'pour créer une nouvelle campagne.',
    },
    contactListing: {
        pageTitle: 'Campagnes',
        tabs: {
            all: 'Tous',
            sent: 'Envoyés',
            unsent: 'Non envoyés',
            withReply: 'Avec réponse',
            withoutReply: 'Sans réponse',
        },
        listingHeaders: {
            name: 'Nom',
            phone: 'Téléphone',
            locale: 'Langue',
            sentStatus: "Statut d'envoi",
            reply: 'Réponse',
            actions: 'Actions',
        },
        actions: {
            removeFromCampaign: 'Retirer de la campagne',
            sendMassSms: 'Envoyer un SMS de masse',
            goToConversation: 'Aller à la conversation',
        },
        errors: {
            deleting: "Une erreur s'est produite lors de la supression du contact de la campagne. | Une erreur s'est produite lors de la supression des contacts de la campagne.",
            fetching: "Une erreur s'est produite lors de la récupération des contacts de la campagne.",
        },
        removeFromCampaignModal: {
            title: 'Retirer de la campagne',
            message: 'Voulez-vous vraiment retirer le contact de la campagne? | Voulez-vous vraiment retirer les {number} contacts sélectionnés de la campagne?',
        },
        sendCampaign: "Préparer l'envoi",
        importContacts: 'Importer des contacts',
        noContactsInCampaign: 'Aucun contact',
        toImportContacts: 'pour importer des contacts.',
        toAddContact: 'pour ajouter un contact.',
        noMatchingContacts: 'Aucun contact ne correspond aux filtres',
        wouldYouLikeToAddOne: 'Voulez-vous en ajouter?',
    },
    campaignModal: {
        addTitle: 'Ajouter une campagne',
        editTitle: 'Modifier la campagne',
        name: 'Nom',
        successes: {
            created: 'Campagne créée avec succès.',
            updated: 'Campagne modifiée avec succès.',
            deleted: 'Campagne supprimée avec succès. | Campagnes supprimées avec succès.',
        },
        errors: {
            saving: 'Erreur lors de la sauvegarde de la campagne.',
            deleting: 'Erreur lors de la suppression de la campagne.',
        },
    },
    deleteModal: {
        deleteTitle: 'Suppression de la campagne | Suppression des campagnes',
        deleteMessage: 'Voulez-vous vraiment supprimer la campagne? | Voulez-vous vraiment supprimer les {number} campagnes sélectionnées?',
    },
};
